module.exports = __webpack_public_path__ + "static/media/stareway.4b57ebb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/stareway.png
// module id = 409
// module chunks = 0